import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

export default styled.div`
  grid-area: info;
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-column-gap: 1rem;
  grid-row-gap: 0.25rem;
  grid-template-areas:
    'date description status'
    'user amount status';

  ${upTo('md')`
    grid-template-columns: auto 1fr;
    grid-template-areas:
      'date description'
      'user amount'
      'user status';
  `}

  ${upTo('sm')`
    grid-template-columns: auto 1fr;
    grid-template-areas:
      'date date'
      'user user'
      'amount status'
      'description description';
  `}
`;
